var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sessions-layout"}},[_c('RouterView',{key:_vm.$route.fullPath}),_c('LegalLinks')],1)}
var staticRenderFns = []

export { render, staticRenderFns }